import { render } from "./GetAQuoteButton.vue?vue&type=template&id=654d739c&scoped=true"
import script from "./GetAQuoteButton.vue?vue&type=script&lang=js"
export * from "./GetAQuoteButton.vue?vue&type=script&lang=js"

import "./GetAQuoteButton.vue?vue&type=style&index=0&id=654d739c&scoped=true&lang=css"

import exportComponent from "/home/runner/work/lorem-support-frontend/lorem-support-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-654d739c"]])

export default __exports__